import { writable } from 'svelte/store';
import { VegaStreamProfileLoader } from '../model/profile/VegaStreamProfileLoader';
class ProfileServiceInit {
    constructor() {
        this.profileIcon = writable('');
        this.nickname = writable('');
        this.statusMessage = writable('');
        this.platform = writable('local');
        this.localId = writable('');
        this.twitchId = writable('');
        this.afreecaId = writable('');
    }
    async loadStreamProfile(privateKey) {
        const profile = await new VegaStreamProfileLoader(privateKey).load();
        this.platform.set(profile.platform);
        this.localId.set(profile.localId);
        this.afreecaId.set(profile.afreecaId);
        this.twitchId.set(profile.twitchId);
    }
}
export const ProfileService = new ProfileServiceInit();
